import { isProxy, toRaw } from 'vue'

export const safeStructuredClone = (obj) => {
  // For browsers like Firefox that don't support structuredClone of proxy objects
  try {
    if (isProxy(obj)) {
      return structuredClone(toRaw(obj))
    }
    return structuredClone(obj)
  } catch (e) {
    return JSON.parse(JSON.stringify(obj))
  }
}

export default safeStructuredClone
